import { dataSourceList, delDataSource, dataSourceInfo } from './request';
import dataSourceModel from './dataSourceModel';
import informationModel from './../components/informationModel';
export default {
  components: {
    dataSourceModel,
    informationModel
  },
  data() {
    return {
      dataSourceShow: false,
      informationShow: false,
      form: {},
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '数据源名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '标识'
        },
        dataIndex: 'mark',
        key: 'description',
        align: 'center'
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 150,
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: []
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      const {
        items,
        totalNum
      } = await dataSourceList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.data = items;
      this.pagination.total = totalNum;
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    //删除
    async handleDelete(val) {
      const res = await dataSourceInfo({
        sourceId: val.id
      });
      console.log(res);
      if (res.length != 0) {
        this.informationShow = true;
        this.$nextTick(() => {
          this.$refs.informationRef.init(res, 4);
        });
        return false;
      }
      let _this = this;
      this.$alert(_this.$t('是否确认删除该数据源?'), {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delDataSource({
          sourceId: val.id
        }).then(() => {
          _this.$message.success(this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    handleEdit(val) {
      this.dataSourceShow = true;
      this.$nextTick(() => {
        this.$refs.dataSourceRef.init(val);
      });
    }
  }
};